import * as Yup from "yup";
import { ComponentElement, FormFieldsDoctor, FormType, Itemisation } from "libs/types/mhaForms";

const componentElements: ComponentElement[] = [
  {
    component: "Text",
    componentProps: {
      instruction: "In my opinion,",
    },
    fullWidth: true,
  },
  {
    component: "Text",
    componentProps: {
      instruction:
        "(a) this patient is suffering from mental disorder of a nature or degree which warrants the detention of the patient in hospital for assessment (or for assessment followed by medical treatment) for at least a limited period,",
    },
    fullWidth: true,
    genericProps: {
      indentation: 1,
    },
  },
  {
    component: "Text",
    componentProps: {
      instruction: "AND",
    },
    fullWidth: true,
  },
  {
    component: "Text",
    componentProps: {
      instruction: "(b) ought to be so detained",
    },
    genericProps: {
      indentation: 1,
    },
    fullWidth: true,
  },
  {
    component: "Checkbox",
    fieldName: FormFieldsDoctor.ReasonsForDetention,
    componentProps: {
      itemisation: Itemisation.ROMAN,
      options: [
        {
          status: "health",
          label: "in the interests of the patient's own health",
        },
        {
          status: "safety",
          label: "in the interests of the patient's own safety",
        },
        {
          status: "protectionOfOthers",
          label: "with a view to the protection of other persons.",
        },
      ],
    },
    genericProps: {
      indentation: 2,
    },
  },
  {
    component: "Text",
    componentProps: {
      guidance: "(Check as applicable)",
      pdfOnlyGuidance: "(Delete the indents not applicable)",
    },
    fullWidth: true,
    genericProps: {
      indentation: 2,
    },
  },
  {
    component: "Text",
    componentProps: {
      instruction: `My reasons for these opinions are:\n\n`,
      guidance:
        "(Your reasons should cover both (a) and (b) above. As part of them: describe the patient's symptoms and behaviour and explain how those symptoms and behaviour lead you to your opinion; explain why the patient ought to be admitted to hospital and why informal admission is not appropriate.)",
    },
    genericProps: {
      pdfBreak: [FormType.A4],
    },
    fullWidth: true,
  },
  {
    component: "BottomTextInput",
    fieldName: FormFieldsDoctor.DetailedReasons,
    fullWidth: true,
    componentProps: {
      label: "Reasons",
      helperText: `My reasons for these opinions are:\n\n(Your reasons should cover both (a) and (b) above. As part of them: describe the patient's symptoms and behaviour and explain how those symptoms and behaviour lead you to your opinion; explain why the patient ought to be admitted to hospital and why informal admission is not appropriate.)`,
      buttonLabel: "Reasons",
      defaultText: "No details currently given",
    },
  },
];

export default {
  title: "Opinion",
  state: {
    reasonsForDetention: [],
    detailedReasons: "",
  },

  validation: Yup.object().shape({
    reasonsForDetention: Yup.array().min(1, "Please select at least one of the options").required(),
    detailedReasons: Yup.string().trim().min(20, "Please enter detailed reasons").required("Please enter a reason"),
  }),

  componentElements,
};
